import service from '@/store/services/brand-service';

const state = {
  list: [],
  brand: {},
  inverter_brands: [],
};

const mutations = {
  SET_BRANDS: (state, list) => {
    state.list = list;
  },
  SET_BRAND: (state, brand) => {
    state.brand = brand;
  },
  SET_INVERTERS_BRANDS: (state, inverter_brands) => {
    state.inverter_brands = inverter_brands;
  },
};

const actions = {
  create({ _ }, brand) {
    return service.create(brand).then((response) => {
      return Promise.resolve(response.data);
    }).catch((error) => {
      return Promise.reject(error);
    });
  },
  read({ commit }, params) {
    return service.read(params)
      .then(({ brands }) => {
        commit('SET_BRANDS', brands);
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  update({ _ }, params) {
    return service.update(params)
      .then((response) => {
        return Promise.resolve(response.data);
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  destroy({_},brand) {
    return service.destroy(brand).then((response) => {
      return Promise.resolve(response.data);
    }).catch((error) => {
      return Promise.reject(error);
    });
  },
  getBrandById({ commit }, id) {
    return service.getBrandById(id).then((response) => {
      commit('SET_BRAND', response.data);
      return Promise.resolve(response.data);
    });
  },
  getInverterBrands({ commit }, params) {
    return service.getInverterBrands(params)
      .then(({ brands }) => {
        commit('SET_INVERTERS_BRANDS', brands);
        return Promise.resolve(brands);
      }).catch((error) => {
        return Promise.resolve([]);
      });
  },
  attachFiles({ _ }, params) {
    return service.attachFiles(params).then(({ brand }) => {
      return brand;
    });
  },
  removeFile({ _ }, params) {
    return service.removeFile(params);
  },
};

const getters = {
  list: state => state.list,
  brand: state => state.brand,
  inverter_brands: state => state.inverter_brands,
};

const brand = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default brand;
